import { useTheme } from '@mui/material/styles';
import { IconCheck, IconX } from '@tabler/icons-react';

interface MultiDocumentAgentEnabledCellProps {
  enabled: boolean;
}

function MultiDocumentAgentEnabledCell({
  enabled,
}: MultiDocumentAgentEnabledCellProps) {
  const theme = useTheme();

  if (enabled) {
    return <IconCheck color={theme.palette.success.main} />;
  }

  return <IconX color={theme.palette.error.main} />;
}

export default MultiDocumentAgentEnabledCell;
